module.exports = __webpack_public_path__ + "static/media/coursehero_logo.162dbffd.png";